import { IkasProduct } from "../product";

export type IkasRaffleDateRangeField = {
  start: number | null;
  end: number | null;
};

export enum IkasRaffleVerificationType {
  EMAIL = "EMAIL",
  MERSIS = "MERSIS",
}

export type IkasRaffle = {
  id: string;
  createdAt: number;
  updatedAt: number;
  deleted: boolean | null;
  dateRange: IkasRaffleDateRangeField | null;
  metadata: IkasRaffleMetaData | null;
  name: string;
  requiredCustomerAccount: boolean;
  status: boolean;
  variants: IkasRaffleAppliedProduct[] | null;
  products: IkasProduct[];
  verificationType: IkasRaffleVerificationType;
};

export enum IkasRaffleMetadataTargetType {
  RAFFLE = "RAFFLE",
}

export type IkasRaffleMetaData = {
  id: string;
  createdAt: number;
  updatedAt: number;
  deleted: boolean | null;
  description: string | null;
  pageTitle: string | null;
  slug: string;
  targetId: string | null;
  targetType: IkasRaffleMetadataTargetType | null;
  canonicals: string[] | null;
  disableIndex: boolean | null;
};

export type IkasRaffleParticipant = {
  id: string | null;
  createdAt: number | null;
  updatedAt: number | null;
  deleted: boolean | null;
  customerId: string | null;
  raffleId: string;
  firstName: string;
  lastName: string;
  fullName: string | null;
  email: string;
  applicationDate: number;
  phone: string | null;
  isDeliveredCargo: boolean | null;

  raffle: IkasRaffle | null;
  status: IkasRaffleParticipantStatus | null;
  extraData: Record<string, any> | null;
  appliedProduct: IkasRaffleAppliedProduct;
};

export type IkasRaffleAppliedProduct = {
  productId: string;
  variantId: string;
};

export enum IkasRaffleParticipantStatus {
  COMPLETED = "COMPLETED",
  IN_PROGRESS = "IN_PROGRESS",
  LOSER = "LOSER",
  WINNER = "WINNER",
}
